// src/components/StepperNav.js

import React from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';

const steps = [
    'Vorderseite erfassen',
    'Rückseite erfassen',
    'Verordnung prüfen',
    'Verordnung abrechnen',
];

const StepperNav = ({ activeStep, onStepClick, completedSteps }) => {
    return (
        <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};

                // Hier könnten wir Completed-Styles setzen
                // (MUI hat auch eine integrierte "completed" Logik, 
                //  aber wir können es auch manuell steuern)

                return (
                    <Step
                        key={label}
                        {...stepProps}
                        // Klick auf bereits erledigte Steps erlauben:
                        onClick={() => {
                            if (index <= completedSteps) {
                                onStepClick(index);
                            }
                        }}
                    >
                        <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                );
            })}
        </Stepper>
    );
};

export default StepperNav;
